/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: Patrick
 * Created: 22.06.12, 17:11
 *
 * $URL$
 * $Rev$
 * $Author$
 * $Date$
 * $Id$
 */


import {getLogger} from "@goodgamestudios/logger";
const logger = getLogger("CoreJS.BasicEnvironmentDetector");

import { IEnvironmentGlobals } from "../IEnvironmentGlobals";
import { BasicConstants } from "../constants/BasicConstants";
import { detectFeatureBranchEnvironment } from "./FeatureBranchDetector";
import { info } from "../../logging/info";

import Container = createjs.Container;

export class BasicEnvironmentDetector {
    /**
     * Detects the runtime environment from flashvars and/or the referrer url.
     */
    public static detectRuntimeEnvironment(target: Container, env: IEnvironmentGlobals): void {
        //-----------------------------------------------
        // Detect if client is running in TEST mode
        //-----------------------------------------------
        if (target.loaderInfo.parameters[BasicConstants.IS_TEST_PARAMETER]) {
            // If flashvar IS_TEST is defined, set TEST mode
            env.isTest = Boolean(target.loaderInfo.parameters[BasicConstants.IS_TEST_PARAMETER]);
        }
        else {
            // If client is running in "test"-folder, set TEST mode
            env.isTest = target.loaderInfo.url.indexOf(BasicConstants.TEST_FOLDER) != -1;
            // If client is not running in "test"-folder, check additionally if it's running
            env.isTest = env.isTest || (target.loaderInfo.url.indexOf("/gamesocial-test/") != -1);
            env.isTest = env.isTest || (target.loaderInfo.url.indexOf(BasicConstants.DOMAIN_INTERNAL_DNS) != -1);
            env.isTest = env.isTest || BasicConstants.isLocalHost(target.loaderInfo.url);
        }

        // If flashvar IS_LOCALE is defined, set TEST mode
        if (target.loaderInfo.parameters[BasicConstants.IS_LOCALE_PARAMETER]) {
            env.isTest = Boolean(target.loaderInfo.parameters[BasicConstants.IS_LOCALE_PARAMETER]);
        }

        //-----------------------------------------------
        // Detect if client is running in LIVE TEST mode
        //-----------------------------------------------
        if (target.loaderInfo.url.indexOf(BasicConstants.LIVE_TEST_FOLDER) != -1) {
            env.isLiveTest = true;
        }

        //-----------------------------------------------
        // Detect if client is running locally.
        //-----------------------------------------------
        env.isLocal = target.loaderInfo.url.indexOf(BasicConstants.LOCALE_URL) == 0 || target.loaderInfo.url.indexOf(BasicConstants.LOCAL_HOST) != -1;
        env.isLocalHost = BasicConstants.isLocalHost(target.loaderInfo.url);
        env.isPrivateTestServer = target.loaderInfo.url.indexOf(BasicConstants.PRIVATE_TEST_SERVER_URL) != -1;
        env.isUsabilityTest = target.loaderInfo.url.indexOf(BasicConstants.USABILITYTEST_FOLDER) != -1;
        env.isPreClient = target.loaderInfo.url.indexOf(BasicConstants.PRECLIENT_FOLDER) != -1;
        env.isLocaTest = target.loaderInfo.url.indexOf(BasicConstants.LOCA_TEST_FOLDER) != -1;

        // TODO: this is a workaround for HTML5. Please remove the line below after HTML-1994 is closed.
        env.isLocalHost = env.isLocal = true;



        //-----------------------------------------------
        // Detect if client is running in DEV mode
        //-----------------------------------------------
        env.isDevTest = target.loaderInfo.url.indexOf(BasicConstants.DEV_TEST_FOLDER) != -1;

        //-----------------------------------------------
        // Detect if client is running on a live branching environment
        //-----------------------------------------------
        env.isLiveBranchingEnvironment = target.loaderInfo.url.indexOf(BasicConstants.LIVE_BRANCHING_ENVIRONMENT) != -1;

        //-----------------------------------------------
        // Check if client is running on a feature branch environment
        //-----------------------------------------------
        let { isFeatureBranch, id, environment } = detectFeatureBranchEnvironment(target.loaderInfo.url);

        env.isFeatureBranchEnvironment = isFeatureBranch;
        env.featureBranchId = id;
        env.featureBranchEnvironment = environment;

        //-----------------------------------------------
        // Output detected environment
        //-----------------------------------------------
        info(
            "isTest: " + env.isTest +
            ", isLiveTest: " + env.isLiveTest +
            ", isDev: " + env.isDevTest +
            ", isLocal: " + env.isLocal +
            ", isLocalHost: " + env.isLocalHost +
            ", isPrivateTestServer: " + env.isPrivateTestServer +
            ", isUsabilityTest: " + env.isUsabilityTest +
            ", env.isPreClient: " + env.isPreClient +
            ", isLiveBranchingEnvironment: " + env.isLiveBranchingEnvironment +
            ", isFeatureBranchEnvironment: " + env.isFeatureBranchEnvironment
        );

        logger.debug(
            "isTest: " + env.isTest +
            ", isLiveTest: " + env.isLiveTest +
            ", isDev: " + env.isDevTest +
            ", isLocal: " + env.isLocal +
            ", isLocalHost: " + env.isLocalHost +
            ", isPrivateTestServer: " + env.isPrivateTestServer +
            ", isUsabilityTest: " + env.isUsabilityTest +
            ", env.isPreClient: " + env.isPreClient +
            ", isLiveBranchingEnvironment: " + env.isLiveBranchingEnvironment +
            ", isFeatureBranchEnvironment: " + env.isFeatureBranchEnvironment
        );
    }
}

